module.exports = __webpack_public_path__ + "img/ok-icon.01d43a1.png";